import React from 'react';

function Footer() {
  return (
    <footer className="footer">
    <p>© {new Date().getFullYear()} Alex Mahadevan. All rights reserved. Email me: alexmahadevan@gmail.com.</p>
  </footer>
  );
}

export default Footer;